import { createFileRoute } from "@tanstack/react-router";
import { useEffect, type JSX } from "react";

import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";

import { AppointmentTypeList } from "@/components/appointment/type/appointment-type-list";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { useClearAppointmentTypeDrafts } from "@/hooks/use-appointment-type-form-draft";
import { useGraphQL } from "@/hooks/use-graphql";

const AppointmentTypesPageQuery = graphql(/* GraphQL */ `
  query AppointmentTypesPageQuery {
    ...AppointmentTypeListQueryFragment
  }
`);

const AppointmentTypesPage = (): JSX.Element => {
  const queryResult = useGraphQL(AppointmentTypesPageQuery);

  const clearAppointmentTypeDrafts = useClearAppointmentTypeDrafts();

  useEffect(() => {
    clearAppointmentTypeDrafts();
  }, [clearAppointmentTypeDrafts]);

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Tipos de atendimento" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <AppointmentTypeList appointmentTypeList={data} />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/schedule-options/appointment-types/")({
  component: AppointmentTypesPage,
  pendingComponent: () => <PendingComponent title="Tipos de atendimento" />,
});
